import './App.css';
import Home from './pages/home';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
